export default __webpack_public_path__ + "static/media/img-guide-03.a90ac977.png";